import { InjectionToken } from '@angular/core';

import { SecurityContextService } from 'rev-shared/security/SecurityContext.Service';

export const SECURITY_STARTUP_INJECTION_TOKEN: InjectionToken<Promise<any>> = new InjectionToken('SecurityStartup');

export function getSecurityStartup(SecurityContext: SecurityContextService): Promise<any> {
	return SecurityContext.initializationPromise;
}
